import React, { useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router';
import { CheckOutlined, CrownOutlined, FileTextOutlined, WalletOutlined, PlayCircleOutlined, CheckCircleFilled } from '@ant-design/icons';
import { Button } from 'antd';
import { useUserActions } from '@/store/userStore';
import { useLoginStateContext } from '../sys/login/providers/LoginStateProvider';
import { useRouter } from '@/router/hooks';
import { useMultiTabsContext } from '@/layouts/dashboard/multi-tabs/providers/multi-tabs-provider';
const TransferDashboardSuccessScreen = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const plan = searchParams.get('plan') || 'Starter';
  const count = searchParams.get('count') || '5';
  const credits = searchParams.get('credits') || '500';
  const {closeAll} = useMultiTabsContext();
  const {
    replace
  } = useRouter();
  const {
    clearUserInfoAndToken
  } = useUserActions();
  const {
    backToLogin
  } = useLoginStateContext();
  const logout = () => {
    try {
      clearUserInfoAndToken();
      backToLogin();
    } catch (error) {
      console.log(error);
    } finally {
      replace("/login");
    }
  };

  useEffect(() => {
    const originalStyle = document.body.style.pointerEvents;
    document.body.style.pointerEvents = 'none';
    return () => {
      document.body.style.pointerEvents = originalStyle;
    };
  }, []);
  return <div className="w-full h-full bg-[#F8FAFC] dark:bg-[#020617] flex flex-col items-center justify-center relative p-8 pointer-events-auto">
      {/* Sparkles Decoration */}
      <div className="absolute top-[18%] left-[46%] text-[#E77995] text-lg font-serif select-none">✦</div>
      <div className="absolute top-[24%] left-[54%] text-[#F3C34F] text-sm font-serif select-none">✦</div>
      <div className="absolute top-[32%] left-[44%] text-[#84D8A8] text-xs font-serif select-none">✦</div>
      <div className="absolute top-[28%] left-[57%] text-[#E77995] text-xs font-serif select-none">✦</div>

      {/* Checkmark Icon */}
      <div className="w-24 h-24 rounded-full bg-[#D1F3DF] dark:bg-[#10B981]/20 flex items-center justify-center mb-8 shadow-sm z-10">
        <CheckOutlined className="text-[40px] text-[#10B981] font-bold" />
      </div>

      {/* Titles */}
      <h1 className="text-[32px] font-bold text-gray-800 dark:text-white mb-3 text-center">Welcome to {plan.charAt(0).toUpperCase() + plan.slice(1)}!</h1>
      <h2 className="text-lg font-bold text-[#10B981] mb-6 text-center">Your dashboards have been transferred successfully.</h2>
      <p className="text-gray-500 dark:text-gray-400 text-center max-w-lg mb-10 text-[15px]">
        You now have access to all your dashboards, {credits} credits, <br />and all the features included in the {plan.charAt(0).toUpperCase() + plan.slice(1)} plan.
      </p>

      {/* Info Cards */}
      <div className="flex gap-4 w-full max-w-5xl mb-8">
        {/* Card 1 */}
        <div className="flex-1 bg-white dark:bg-[#0f172a] rounded-xl border border-[#FFE1E6] dark:border-slate-700 p-6 flex flex-col items-center shadow-sm relative overflow-hidden">
          <div className="w-12 h-12 bg-[#FFF5F6] dark:bg-[#C41230]/20 rounded-lg flex items-center justify-center mb-4 text-[#C41230]">
            <FileTextOutlined className="text-2xl" />
          </div>
          <div className="text-gray-500 dark:text-gray-400 text-sm font-semibold mb-2">Dashboards Transferred</div>
          <div className="text-3xl font-bold text-gray-800 dark:text-white mb-2">{count}</div>
          <div className="text-gray-400 dark:text-gray-500 text-xs">dashboard(s)</div>
        </div>

        {/* Card 2 */}
        <div className="flex-1 bg-white dark:bg-[#0f172a] rounded-xl border border-[#FFE1E6] dark:border-slate-700 p-6 flex flex-col items-center shadow-sm">
          <div className="w-12 h-12 bg-[#FFF5F6] dark:bg-[#C41230]/20 rounded-lg flex items-center justify-center mb-4 text-[#C41230]">
            <WalletOutlined className="text-2xl" />
          </div>
          <div className="text-gray-500 dark:text-gray-400 text-sm font-semibold mb-2">Credits Added</div>
          <div className="text-3xl font-bold text-gray-800 dark:text-white mb-2">{credits}</div>
          <div className="text-gray-400 dark:text-gray-500 text-xs">credits</div>
        </div>

        {/* Card 3 */}
        <div className="flex-1 bg-white dark:bg-[#0f172a] rounded-xl border border-[#FFE1E6] dark:border-slate-700 p-6 flex flex-col items-center shadow-sm">
          <div className="w-12 h-12 bg-[#FFF5F6] dark:bg-[#C41230]/20 rounded-lg flex items-center justify-center mb-4 text-[#C41230]">
            <CrownOutlined className="text-2xl" />
          </div>
          <div className="text-gray-500 dark:text-gray-400 text-sm font-semibold mb-2">Current Plan</div>
          <div className="text-3xl font-bold text-gray-800 dark:text-white mb-2 capitalize">{plan}</div>
          <div className="text-[#10B981] text-sm font-semibold">Active</div>
        </div>

        {/* Card 4 */}
        {/* <div className="flex-1 bg-white dark:bg-[#0f172a] rounded-xl border border-[#FFE1E6] dark:border-slate-700 p-6 flex flex-col items-center shadow-sm">
          <div className="w-12 h-12 bg-[#FFF5F6] dark:bg-[#C41230]/20 rounded-lg flex items-center justify-center mb-4 text-[#C41230]">
            <CalendarOutlined className="text-2xl" />
          </div>
          <div className="text-gray-500 dark:text-gray-400 text-sm font-semibold mb-2">Billing Cycle</div>
          <div className="text-3xl font-bold text-gray-800 dark:text-white mb-2 capitalize">{billingCycle}</div>
          <div className="text-gray-400 dark:text-gray-500 text-xs">Next renewal on 22 Jun 2026</div>
         </div> */}
      </div>

      {/* Banner */}
      <div className="bg-[#EEF9F2] dark:bg-[#10B981]/10 border border-[#BDE5CE] dark:border-[#10B981]/20 rounded-xl p-6 w-full max-w-5xl flex items-center justify-between mb-10 shadow-sm relative overflow-hidden">
        <div className="flex items-start gap-4 z-10">
          <div className="mt-1">
             <CheckCircleFilled className="text-3xl text-[#10B981]" />
          </div>
          <div>
            <h3 className="text-xl font-bold text-gray-800 dark:text-white mb-1">You're all set!</h3>
            <p className="text-gray-600 dark:text-gray-400 text-[15px]">Please logout and login again so that your new {plan.charAt(0).toUpperCase() + plan.slice(1)} plan reflects on our app.</p>
          </div>
        </div>
        
        {/* Illustration graphic (mocked) */}
        <div className="absolute right-0 top-0 bottom-0 opacity-80 pointer-events-none w-64 h-full hidden md:flex items-center justify-end pr-8">
            <svg width="160" height="80" viewBox="0 0 160 80" fill="none" xmlns="http://www.w3.org/2000/svg">
              {/* Dashboard Wireframe */}
              <rect x="10" y="15" width="70" height="50" rx="4" fill="white" stroke="#A7E2C3" strokeWidth="2" />
              <rect x="15" y="25" width="25" height="30" rx="2" fill="#EAF6ED" stroke="#A7E2C3" strokeWidth="1" />
              <rect x="45" y="25" width="30" height="30" rx="2" fill="#EAF6ED" stroke="#A7E2C3" strokeWidth="1" />
              {/* Rocket Body */}
              <path d="M120 15 C 130 15, 140 25, 140 40 C 140 55, 130 65, 120 65 C 110 65, 100 55, 100 40 C 100 25, 110 15, 120 15 Z" fill="#E77995" />
              {/* Window */}
              <circle cx="120" cy="40" r="8" fill="white" />
              {/* Fins */}
              <path d="M100 40 L90 30 L95 45 Z" fill="#C41230" />
              <path d="M100 40 L90 50 L95 35 Z" fill="#C41230" />
              {/* Fire */}
              <path d="M100 40 L70 50 L85 40 L70 30 Z" fill="#F3C34F" />
              {/* Sparkles */}
              <circle cx="85" cy="15" r="2" fill="#10B981" />
              <circle cx="145" cy="30" r="2" fill="#F3C34F" />
              <circle cx="130" cy="70" r="1.5" fill="#C41230" />
            </svg>
        </div>
      </div>

      {/* Buttons */}
      <div className="flex justify-center gap-5 z-10">
        <Button type="primary" icon={<PlayCircleOutlined />} size="large" className="w-56 font-semibold bg-[#C41230] hover:bg-[#A30F28] h-12 text-base rounded-md" onClick={logout}>
          Logout
        </Button>
        {/* <Button icon={<CrownOutlined />} size="large" className="w-48 font-semibold text-[#C41230] border-[#C41230] hover:bg-[#FFF5F6] hover:text-[#C41230] hover:border-[#C41230] dark:bg-transparent dark:hover:!bg-[#C41230]/20 h-12 text-base rounded-md" onClick={() => closeAll()}>
          Back to Home
        </Button> */}
      </div>
    </div>;
};
export default TransferDashboardSuccessScreen;